import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Modal,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import ReactResizeDetector from 'react-resize-detector';
import { getViewableDimensions } from '../../../App/AppReducer';
import SearchField from '../../../../components/search-field';
import DataTypeCellRenderer from '../../components/cells/DataTypeCellRenderer';
import APICellRenderer from '../../components/cells/APICellRenderer';
import CustomHeader from '../../../../components/god-table/header';
import FieldLabelCellRenderer from '../../components/cells/FieldLabelCellRenderer';

function ButtonRenderer(props) {
  return (
    <Button onClick={() => { props.onClick(props.data); }} bsStyle="primary" bsSize="xs">select</Button>
  );
}
ButtonRenderer.propTypes = {
  onClick: PropTypes.func,
  data: PropTypes.shape({}).isRequired,
};
ButtonRenderer.defaultProps = {
  onClick: () => {},
};

class FieldModal extends Component {
  constructor() {
    super();
    this.state = {
      navBarHeight: 0,
    };
    this.close = this.close.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.onResizNavBar = this.onResizNavBar.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  onResizNavBar(width, navBarHeight) {
    this.setState({ navBarHeight });
  }
  handleSearch(query) {
    if (this.gridApi) {
      this.gridApi.setQuickFilter(query);
    }
  }
  handleCellClick(field) {
    this.props.onSelect(field);
    this.close();
  }

  close() {
    this.props.onClose();
  }

  renderTable() {
    const { viewableDimensions, fields } = this.props;
    const { navBarHeight } = this.state;
    const viewableHeight = Math.min(viewableDimensions.height - navBarHeight, 400);

    const columnDefs = [
      {
        headerName: 'Field Name',
        field: 'label',
        suppressMenu: true,
        width: 200,
        suppressMovable: true,
        cellRenderer: FieldLabelCellRenderer,
        pinned: 'left',
      },
      {
        headerName: 'API Name',
        field: 'name',
        suppressMenu: true,
        width: 180,
        cellRenderer: APICellRenderer,
        suppressMovable: true,
      },
      {
        headerName: 'Data Type',
        field: 'type',
        suppressMenu: true,
        width: 100,
        suppressMovable: true,
        cellRenderer: DataTypeCellRenderer,
      },
      {
        headerName: 'Select',
        field: '_id',
        suppressMenu: true,
        width: 80,
        suppressMovable: true,
        cellRenderer: ButtonRenderer,
        cellRendererParams: {
          onClick: this.handleCellClick,
        },
        cellStyle: () => ({ marginTop: '-2px' }),
      },
    ];

    return (
      <div className="ag-theme-alpine" style={{ height: viewableHeight, width: '100%' }}>
        <AgGridReact
          reactNext
          enableColResize
          enableSorting
          animateRows
          columnDefs={columnDefs}
          getRowId={(params) => params.data._id}
          onGridReady={this.onGridReady}
          rowData={fields}
        />
      </div>
    );
  }
  renderContent() {
    const { fields } = this.props;
    if (fields.length === 0) {
      return (
        <div className="alert alert-waring">No fields found</div>
      );
    }
    return (
      <div>
        <nav className="navbar navbar-default navbar-controls">
          <form className="navbar-form navbar-left">
            <SearchField collapsible={false} onSearch={this.handleSearch} />
          </form>
          <ReactResizeDetector handleHeight onResize={this.onResizNavBar} />
        </nav>
        {this.renderTable()}
      </div>
    );
  }
  render() {
    const { show } = this.props;
    return (
      <Modal key="modal" show={show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>Available Fields</h4>
        </Modal.Header>
        <Modal.Body>
          <div>{this.renderContent()}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}


FieldModal.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
  })).isRequired,
  show: PropTypes.bool,
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  viewableDimensions: PropTypes.shape({}).isRequired,
};

FieldModal.defaultProps = {
  show: false,
  onClose: () => {},
  onSelect: () => {},
};

function mapStateToProps(state) {
  return {
    viewableDimensions: getViewableDimensions(state),
  };
}
export default connect(mapStateToProps)(FieldModal);